/************************* Helpers *************************/

let gOverlayLoaded = false;

const createGOverlay = () => {
    const overlay = document.createElement('div');
    overlay.classList.add('g-overlay');
    overlay.setAttribute('data-g-close', '');
    document.body.append(overlay)
    gOverlayLoaded = true;
};


const getPageContentHtml = async (pageUrl) => {
    try {
        // Get page as JSON to get body_html, to inject in modal/ drawer
        const pageJson = await (
            await fetch(pageUrl + '.json')
                .then(res => res.json()));
        return pageJson.page.body_html;
    } catch (error) {
        console.log('Error: ', error);
        return '';
    }
};

const getSectionHtml = async (section, canonicalUrl) => {
    try {
        let url = window.location.pathname + '/?sections=' + section;
        if (canonicalUrl) {
            url = new URL(canonicalUrl).pathname + '/?sections=' + section;
        }

        // Get page as JSON to get body_html, to inject in modal/ drawer
        const sectionJson = await (
            await fetch(url)
                .then(res => res.json()));
        return sectionJson[section];
    } catch (error) {
        console.log('Error: ', error);
        return '';
    }
};

/************************* Renders *************************/

const closeText = theme?.strings?.closeCart ? theme.strings.closeCart : 'close'
const closeButton = `
<button name="Close" class="g-close-button" data-g-close type="button" title="${ closeText }">
    <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
        <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
    </svg></button>
</button>`

const renderDefaultModal = ({ header, body, footer }) => {


    let headerHTML = ``
    let bodyHtml = ``;
    let footerHtml = ``;

    if (header) {
        headerHTML = `<h4 class="h3">${ header }</h4>`;
    }
    if (body) {
        bodyHtml = `<div class="g-modal__container">${ body }</div>`;
    }
    if (footer) {
        footerHtml = `<footer class="g-modal__footer"> ${ footer }</footer >`;
    }

    const htmlString = `
    <section class="g-modal">
        <header class="g-modal__header">
            ${ headerHTML }
            ${ closeButton }
        </header>
        ${ bodyHtml }
        ${ footerHtml }
    </section>`;

    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');
    const modalHtml = html.body.firstElementChild;

    return modalHtml;
};


const renderDefaultDrawer = ({ header, body, footer }) => {

    let headerHTML = ``;
    let footerHtml = ``;

    if (header) {
        headerHTML = `<h3 class="g-drawer__title"> ${ header }</h3>`
    }
    if (body) {
        bodyHtml = `<div class="g-drawer__body">${ body }</div>`;
    }
    if (footer) {
        footerHtml = `<footer class="g-drawer__footer"> ${ footer }</footer> `
    }

    const htmlString = `
    <section class="g-drawer">
        <header class="g-drawer__header">
            ${ headerHTML }
            ${ closeButton }
        </header>
        ${ bodyHtml }
        ${ footerHtml }
    </section>`;

    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');
    const drawerHtml = html.body.firstElementChild;

    drawerHtml.querySelector('.g-drawer__content')

    return drawerHtml
}

const renderImpulseDrawer = ({ header, body, footer }) => {
    let headerHTML = ``;
    let footerHtml = ``;

    if (header) {
        headerHTML = `<div class="h2 drawer__title"> ${ header }</div>`
    }
    if (body) {
        bodyHtml = body;
    }
    if (footer) {
        footerHtml = `<footer class="g-drawer__footer"> ${ footer }</footer> `
    }

    const htmlString = `
    <section class="drawer drawer--right">
        <header class="drawer__fixed-header">
        <div class="drawer__header appear-animation appear-delay-1">
            ${ headerHTML }
            <div class="drawer__close">
            <button type="button" class="drawer__close-button js-drawer-close">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>
                <span class="icon__fallback-text">${ closeText }</span>
            </button>
            </div>
        </div>
        </header>
        <div class="drawer__inner appear-animation appear-delay-2">
        <div class="drawer__scrollable">
            <div data-products">
            ${ bodyHtml }
            </div>
            </div>
        </div >
        </div >
        ${ footerHtml }
    </section> `;

    const parser = new DOMParser();
    const html = parser.parseFromString(htmlString, 'text/html');
    const drawerHtml = html.body.firstElementChild;

    drawerHtml.querySelector('.g-drawer__content')

    return drawerHtml
}


/************************* G Opener *************************/

/**
 * G Opener
 * 
 * Settings: if the opener contains "data-g-close" and "this" is click "this" will close 
 */

class GTCOpener {
    constructor() {
        //Default classes
        this.class = {
            open: 'open',
            close: 'close',
            overlayOpen: 'g-overlay-open',
            scrollLock: 'lock'
        }

        this.Click = this.Click.bind(this);
        this.Keydown = this.Keydown.bind(this);
    }

    Init() {
        if (this.settings.rendered === true) {
            this.Open();
        } else {
            this.Create();
        }
    }

    AddOpenerEventListeners() {
        document.addEventListener('click', this.Click, false);
        document.addEventListener("keydown", this.Keydown, false);
    }
    RemoveOpenerEventListeners() {
        document.removeEventListener('click', this.Click, false);
        document.removeEventListener("keydown", this.Keydown, false);
    }

    Click(event) {
        if (!this.main.classList.contains(this.class.open)) return
        const target = event.target;

        // Closes  if clicked outside of the Modal/drawer, or clicking on data-g-close
        if (!this.main.contains(target) || target.hasAttribute('data-g-close')) {
            this.Close();
        }
    }

    Keydown(event) {
        // If Esc key
        if (event.keyCode !== 27) return;
        this.Close();
    }

    Open() {
        this.main.classList.add(this.class.open);
        document.body.classList.add(this.class.overlayOpen, this.class.scrollLock);
        setTimeout(() => {
            this.AddOpenerEventListeners();
        }, 0);
    }

    Close() {
        this.main.classList.remove(this.class.open);
        document.body.classList.remove(this.class.overlayOpen, this.class.scrollLock);
        setTimeout(() => {
            this.RemoveOpenerEventListeners();
        }, 0);
    }

    async Create() {
        let header = this.settings.title;
        let body = '';
        let footer = '';

        if (this.settings.content) {
            body = this.settings.content;
        }
        else if (this.settings.url) {
            body = await getPageContentHtml(this.settings.url);
        }
        else if (this.settings.section) {
            const canonicalUrl = this.settings.canonicalUrl ? this.settings.canonicalUrl : null;
            body = await getSectionHtml(this.settings.section, canonicalUrl);
        }

        const html = this.render({ header, body, footer });

        if (!gOverlayLoaded) {
            createGOverlay();
        }

        if (this.settings?.class) {
            const classes = this.settings.class.split(' ').filter((letter) => letter !== "");;
            html.classList.add(...classes)
        }

        if (this.settings?.id) {
            html.setAttribute('id', this.settings.id);
        }

        document.body.append(html);

        //This forces repaint
        void html.offsetHeight;

        this.settings.rendered = true
        this.main = html;
        this.trigger.setAttribute('loaded', 'true');


        this.Open();
        document.addEventListener(`gtc-opener:open.${ this.settings.id }`, () => this.Open());
    }
}

/************************* G Modal *************************/
class GTCModal extends GTCOpener {
    constructor({ trigger }) {
        super();

        const settings = trigger.hasAttribute('data-gtc-opener') ? { ...JSON.parse(trigger.dataset.gtcOpener) } : null;

        if (!settings) return;

        this.render = renderDefaultModal;

        this.trigger = trigger
        this.settings = {
            rendered: false,
            ...settings
        };

        this.Init();
    }
}


/************************* G Drawer *************************/

class GTCDrawer extends GTCOpener {
    constructor({ trigger }) {
        super();

        const settings = trigger.hasAttribute('data-gtc-opener') ? { ...JSON.parse(trigger.dataset.gtcOpener) } : null;

        if (!settings) return;

        //Needs a render to display the content 
        this.render = renderImpulseDrawer;

        this.trigger = trigger
        this.settings = {
            rendered: false,
            ...settings
        };

        this.Init();
    }

    /**
     * This is custom functions for impulse drawer
     */

    Init() {
        if (this.settings.rendered === true) {
            this.Open();
        } else {
            this.Create();
        }
    }


    Click(event) {
        if (!this.main.classList.contains('drawer--is-open')) return
        const target = event.target;

        if (!this.main.contains(target) || target.classList.contains('js-drawer-close')) {
            this.Close();
        }
    }

    PrepareTransition(el, callback) {
        el.addEventListener('transitionend', removeClass);

        function removeClass(evt) {
            el.classList.remove('is-transitioning');
            el.removeEventListener('transitionend', removeClass);
        }

        el.classList.add('is-transitioning');
        el.offsetWidth; // check offsetWidth to force the style rendering

        if (typeof callback === 'function') {
            callback();
        }
    }

    Open() {
        document.body.classList.add('lock-scroll');
        this.PrepareTransition(this.main, function() {
            this.main.classList.add('drawer--is-open');
        }.bind(this));

        document.body.classList.add('js-drawer-open');

        setTimeout(() => {
            this.AddOpenerEventListeners();
        }, 0);
    }
    Close() {
        this.PrepareTransition(this.main, function() {
            this.main.classList.remove('drawer--is-open');
        }.bind(this));

        document.body.classList.remove('js-drawer-open', 'lock-scroll');
        document.body.classList.add('js-drawer-closing');

        window.setTimeout(function() {
            document.body.classList.remove('js-drawer-closing');
        }.bind(this), 500);

        setTimeout(() => {
            this.RemoveOpenerEventListeners();
        }, 0);
    }
}

/************************* G - Init *************************/

document.body.addEventListener('click', (e) => {
    const target = e.target;
    const trigger = target.closest('[data-gtc-opener]');
    if (trigger) {
        const settings = JSON.parse(trigger.getAttribute('data-gtc-opener'));
        if (!trigger.hasAttribute('loaded')) {

            switch (settings.type) {
                case 'modal':
                    void new GTCModal({ trigger: trigger });
                    break;
                case 'drawer':
                    void new GTCDrawer({ trigger: trigger });
                    break;
                default:
                    console.warn('No opener "type" is matching.');
                    break;
            }
        }
        else {
            document.dispatchEvent(new CustomEvent(`gtc-opener:open.${ settings.id }`));
        }
    }

})